(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  const root = window.Shopify?.routes?.root || '/';
  const tiers = [{amount:149900,percent:5},{amount:199900,percent:7},{amount:299900,percent:10}];
  const format = cents => {
    try { return new Intl.NumberFormat('en-IN', {style:'currency',currency:document.body.dataset.currency || 'INR'}).format(cents / 100); }
    catch (_) { return '₹' + new Intl.NumberFormat('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2}).format(cents / 100); }
  };
  const escape = value => String(value ?? '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;','\'':'&#39;'}[char]));
  let recommendedFor = '';
  let recommendedProducts = [];
  let suggestionsLoading = false;
  let suggestionsFailed = false;
  let currentCart = null;
  const savingsFingerprint = cart => JSON.stringify([
    String(cart.currency?.iso_code || cart.currency || ''),
    Number(cart.original_total_price || 0),
    Number(cart.total_price || 0),
    (cart.items || []).map(item => [String(item.key), Number(item.quantity), Number(item.original_line_price)]).sort((a, b) => a[0].localeCompare(b[0]))
  ]);
  let savingsSnapshot = null;
  try { savingsSnapshot = JSON.parse(drawer.querySelector('[data-cart-savings-snapshot]')?.textContent || 'null'); } catch (_) {}
  const paintCartSavings = (cart, referenceTotal) => {
    const amount = Math.max(0, referenceTotal - Number(cart.total_price || 0));
    drawer.querySelector('[data-cart-savings]').hidden = amount <= 0;
    drawer.querySelector('[data-cart-savings-value]').textContent = format(amount);
    const originalTotal = drawer.querySelector('[data-cart-original-total]');
    originalTotal.hidden = amount <= 0;
    originalTotal.textContent = format(referenceTotal);
  };
  const paintCartReturnPolicies = () => {
    drawer.querySelectorAll('.paw-return-policy-notice').forEach(el => el.remove());
  };
  const renderCartSavings = async cart => {
    if (savingsSnapshot && savingsFingerprint(savingsSnapshot) === savingsFingerprint(cart)) {
      paintCartSavings(cart, Number(savingsSnapshot.reference_total));
      paintCartReturnPolicies(savingsSnapshot);
      return;
    }
    paintCartSavings(cart, Number(cart.original_total_price || 0));
    if (!cart.items?.length) { savingsSnapshot = null; return; }
    try {
      const response = await fetch(root + 'cart?view=paw-savings', {headers:{Accept:'text/html'},credentials:'same-origin',cache:'no-store'});
      if (!response.ok) throw new Error('Savings unavailable');
      const snapshot = await response.json();
      if (currentCart !== cart || savingsFingerprint(snapshot) !== savingsFingerprint(cart)) return;
      const referenceTotal = Number(snapshot.reference_total);
      if (!Number.isSafeInteger(referenceTotal) || referenceTotal < Number(cart.original_total_price || 0)) return;
      savingsSnapshot = snapshot;
      paintCartSavings(cart, referenceTotal);
      paintCartReturnPolicies(snapshot);
    } catch (_) {}
  };


  let previousTier;
  let celebrationFocus;
  const celebration = drawer.querySelector('[data-cart-celebration]');
  const closeCelebration = () => {
    if (celebration.hidden) return;
    celebration.hidden = true;
    drawer.querySelector('[data-cart-confetti]').replaceChildren();
    if (celebrationFocus?.isConnected) celebrationFocus.focus();
  };
  const celebrate = (tier, cart, total) => {
    if (drawer.dataset.cartCelebrate !== 'true') return;
    const saving = Number(cart.total_discount || 0);
    drawer.querySelector('[data-cart-celebration-title]').textContent = saving > 0 ? 'Discount added to your cart!' : drawer.dataset.cartTierReached.replace('{percent}', tier.percent);
    drawer.querySelector('[data-cart-celebration-label]').textContent = saving > 0 ? 'Your current savings' : 'Potential tier savings';
    drawer.querySelector('[data-cart-celebration-saving]').textContent = format(saving > 0 ? saving : Math.round(total * tier.percent / 100));
    drawer.querySelector('[data-cart-celebration-note]').textContent = 'Eligibility and final savings are confirmed by Shopify at checkout.';
    const confetti = drawer.querySelector('[data-cart-confetti]');
    confetti.replaceChildren();
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const colors = ['#103e76','#ffcf00','#f46a48','#3fa567'];
      for (let i = 0; i < 32; i++) {
        const piece = document.createElement('span');
        piece.style.setProperty('--left', Math.random() * 100 + '%');
        piece.style.setProperty('--color', colors[i % colors.length]);
        piece.style.setProperty('--delay', Math.random() * .6 + 's');
        piece.style.setProperty('--duration', 1.8 + Math.random() * 1.6 + 's');
        confetti.append(piece);
      }
    }
    window.PawCart?.open();
    celebrationFocus = document.activeElement;
    celebration.hidden = false;
    requestAnimationFrame(() => drawer.querySelector('[data-cart-celebration-close]').focus());
  };

  const notice = drawer.querySelector('[data-cart-notice]');
  const showNotice = text => { notice.textContent = text; notice.hidden = false; window.setTimeout(() => { notice.hidden = true; }, 5000); };
  const renderRewards = cart => {
    const total = Number(cart.original_total_price ?? cart.total_price ?? 0);
    const reached = tiers.filter(tier => total >= tier.amount).at(-1);
    const percentage = reached?.percent || 0;
    if (typeof previousTier === 'number' && percentage > previousTier) celebrate(reached, cart, total);
    if (typeof previousTier === 'number' && percentage < previousTier) closeCelebration();
    previousTier = percentage;
    const stage = reached ? tiers.indexOf(reached) : -1;
    const start = reached?.amount || 0;
    const end = tiers[stage + 1]?.amount || start;
    const ratio = end > start ? Math.max(0, Math.min(1,(total - start)/(end - start))) : 1;
    const progress = stage < 0 ? 0 : stage === 2 ? 100 : (stage + ratio) * 50;
    const next = tiers.find(tier => total < tier.amount);
    document.querySelectorAll('[data-cart-rewards]').forEach(section => {
      section.querySelector('[data-cart-reward-message]').textContent = next ? drawer.dataset.cartTierNext.replace('{amount}', format(next.amount - total)).replace('{percent}', next.percent) : drawer.dataset.cartTierReached.replace('{percent}', reached.percent);
      section.querySelector('[data-cart-reward-fill]').style.width = `${progress}%`;
      section.querySelector('[data-cart-reward-track]').setAttribute('aria-valuenow',String(Math.round(total / 100)));
      section.querySelectorAll('[data-cart-tier]').forEach(marker => marker.classList.toggle('is-reached',total >= Number(marker.dataset.cartTier)));
      section.hidden = cart.item_count === 0;
    });
    drawer.querySelector('[data-cart-drawer-footer]').hidden = cart.item_count === 0;
    const couponSection = drawer.querySelector('.cart-drawer__coupon');
    if (couponSection) couponSection.hidden = cart.item_count === 0;
  };
  const card = product => {
    const variant = product.variants?.find(item => item.available);
    if (!variant) return '';
    const image = typeof product.featured_image === 'string' ? product.featured_image : product.featured_image?.src || '';
    const multiple = product.variants?.length > 1;
    return `<article class="cart-upsell__card"><a href="${escape(product.url)}"><img src="${escape(image)}" alt="" loading="lazy" width="60" height="60"></a><div><a href="${escape(product.url)}">${escape(product.title)}</a><strong>${format(variant.price)}</strong></div>${multiple ? `<a class="cart-upsell__add" href="${escape(product.url)}" aria-label="${escape(drawer.dataset.cartOptionsLabel || 'Choose options')}: ${escape(product.title)}">${escape(drawer.dataset.cartSelectLabel || 'Select')}</a>` : `<button type="button" class="cart-upsell__add" data-upsell-add="${escape(variant.id)}">+ Add</button>`}</article>`;
  };
  const renderSuggestions = cart => {
    const present = new Set(cart.items.map(item => Number(item.product_id)));
    document.querySelectorAll('[data-cart-upsell]').forEach(section => {
      const drawerSection = section.hasAttribute('data-drawer-upsell');
      const products = recommendedProducts.filter(product => !present.has(Number(product.id))).slice(0,6);
      const html = products.map(product => card(product)).join('');
      const rail = section.querySelector('[data-upsell-rail]');
      rail.innerHTML = html;
      if (drawerSection) {
        const empty = section.querySelector('[data-upsell-empty]');
        empty.hidden = !!html;
        empty.textContent = suggestionsLoading ? section.dataset.loadingLabel : suggestionsFailed ? section.dataset.errorLabel : section.dataset.emptyLabel;
        section.querySelectorAll('[data-upsell-prev],[data-upsell-next]').forEach(button => { button.disabled = !html; });
        section.hidden = cart.item_count === 0;
      } else {
        section.hidden = !html;
      }
    });
  };
  const loadSuggestions = async cart => {
    const ids = [...new Set(cart.items.map(item => Number(item.product_id)))].slice(0,3);
    const key = ids.join(',');
    if (!key) {
      recommendedFor = ''; recommendedProducts = [];
      suggestionsLoading = false; suggestionsFailed = false; renderSuggestions(cart); return;
    }
    if (recommendedFor === key) { renderSuggestions(cart); return; }
    recommendedFor = key;
    recommendedProducts = [];
    suggestionsLoading = true; suggestionsFailed = false;
    renderSuggestions(cart);
    const request = async (id, intent) => {
      const response = await fetch(`${root}recommendations/products.json?product_id=${encodeURIComponent(id)}&limit=8&intent=${intent}`,{headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('Recommendations unavailable');
      const result = await response.json();
      return Array.isArray(result.products) ? result.products : [];
    };
    const results = await Promise.allSettled([request(ids[0], 'related')]);
    if (recommendedFor !== key) return;
    recommendedProducts = results[0].status === 'fulfilled' ? results[0].value : [];
    suggestionsLoading = false;
    suggestionsFailed = results.every(result => result.status === 'rejected');
    if (currentCart) renderSuggestions(currentCart);
  };
  const renderCouponState = cart => {
    const allocations = [...(cart.cart_level_discount_applications || []), ...cart.items.flatMap(item => (item.line_level_discount_allocations || []).map(allocation => allocation.discount_application))];
    const codes = new Set([...(cart.discount_codes || []).filter(entry => entry.applicable === true).map(entry => entry.code), ...allocations.filter(entry => entry?.type === 'discount_code').map(entry => entry.title)].filter(Boolean).map(code => code.toUpperCase()));
    const summary = drawer.querySelector('[data-cart-coupon-summary]');
    if (summary) {
      summary.hidden = codes.size === 0;
      summary.textContent = [...codes].join(', ') + ' ' + drawer.dataset.couponAppliedLabel;
    }
    drawer.querySelectorAll('.cart-coupon__option').forEach(button => {
      const active = codes.has(button.dataset.couponQuick.toUpperCase());
      button.setAttribute('aria-pressed', String(active));
      button.querySelector('[data-coupon-action]').textContent = active ? drawer.dataset.couponAppliedLabel : drawer.dataset.couponApplyLabel;
    });
    const clear = drawer.querySelector('[data-coupon-clear]');
    if (clear) clear.hidden = codes.size === 0;
    const section = drawer.querySelector('[data-compact-coupons]');
    const status = section?.querySelector('[data-coupon-status]');
    if (section) section.dataset.couponState = codes.size ? 'applied' : '';
    if (status && codes.size && status.hidden) {
      status.textContent = [...codes].join(', ') + ' ' + section.dataset.couponApplied;
      status.hidden = false;
    }
  };
  const update = cart => { currentCart = cart; renderRewards(cart); renderCartSavings(cart); renderCouponState(cart); loadSuggestions(cart); };
  document.addEventListener('paw:cart-updated',event => update(event.detail));
  document.addEventListener('click',async event => {
    if (event.target.closest('[data-cart-celebration-close],[data-cart-close]')) closeCelebration();
    const arrow = event.target.closest('[data-upsell-prev],[data-upsell-next]');
    if (arrow) {
      const rail = arrow.closest('[data-cart-upsell]').querySelector('[data-upsell-rail]');
      rail.scrollBy({left:(arrow.hasAttribute('data-upsell-next')?1:-1)*rail.clientWidth*.85,behavior:'smooth'});
    }
    const add = event.target.closest('[data-upsell-add]');
    if (!add) return;
    add.disabled = true;
    try {
      await window.PawCart.mutate(async refresh => {
        const response = await fetch(`${root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:Number(add.dataset.upsellAdd),quantity:1})});
        if (!response.ok) throw new Error('Unable to add product');
        await refresh();
      });
      if (document.querySelector('.cart-page')) { window.location.reload(); return; }
      window.PawCart.open();
    } catch (_) { showNotice('Could not add this item. Please try again.'); add.disabled = false; }
  });
  document.addEventListener('keydown', event => {
    if (celebration.hidden) return;
    if (event.key === 'Escape') { event.preventDefault(); event.stopImmediatePropagation(); closeCelebration(); }
    if (event.key === 'Tab') { event.preventDefault(); drawer.querySelector('[data-cart-celebration-close]').focus(); }
  }, true);

  drawer.querySelectorAll('[data-coupon-slider]').forEach(slider => {
    const rail = slider.querySelector('[data-coupon-rail]');
    const arrows = slider.querySelector('[data-coupon-arrows]');
    const previous = slider.querySelector('[data-coupon-prev]');
    const next = slider.querySelector('[data-coupon-next]');
    const sync = () => {
      const overflow = rail.scrollWidth > rail.clientWidth + 2;
      arrows.hidden = rail.children.length < 2 || !overflow;
      slider.dataset.single = String(rail.children.length < 2);
      previous.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
    };
    const move = direction => {
      const step = rail.firstElementChild?.getBoundingClientRect().width + 8 || rail.clientWidth;
      rail.scrollBy({left:direction * step,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    };
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    rail.addEventListener('scroll', sync, {passive:true});
    rail.addEventListener('keydown', event => {
      if (event.target !== rail || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      move(event.key === 'ArrowRight' ? 1 : -1);
    });
    const observer = new ResizeObserver(sync);
    observer.observe(rail);
    sync();
  });
  let couponBusy = false;
  const applyCoupon = async (section, code, clear = false) => {
    const status = section.querySelector('[data-coupon-status]');
    const compact = section.dataset.compactCoupons === 'true';
    const message = (key, fallback) => compact ? section.dataset[key] : fallback;
    status.hidden = false;
    code = code.trim();
    if (!code && !clear) { section.dataset.couponState = 'error'; status.textContent = message('couponEmpty', 'Enter a coupon code first.'); section.querySelector('[data-coupon-input]')?.focus(); return; }
    if (couponBusy) return;
    couponBusy = true;
    section.dataset.couponState = 'pending';
    const controls = [...document.querySelectorAll('[data-coupon-quick],[data-coupon-apply],[data-coupon-clear]')];
    controls.forEach(button => { button.disabled = true; });
    status.textContent = message('couponChecking', 'Checking coupon…');
    try {
      const cart = await window.PawCart.mutate(async refresh => {
        const existing = (currentCart?.discount_codes || []).filter(entry => entry.applicable !== false).map(entry => entry.code);
        const allocations = [...(currentCart?.cart_level_discount_applications || []),...(currentCart?.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(entry => entry.discount_application))];
        allocations.filter(entry => entry?.type === 'discount_code').forEach(entry => existing.push(entry.title));
        const codes = clear ? [] : compact ? [code.toUpperCase()] : [...new Set([...existing.filter(Boolean),code].map(entry => entry.toUpperCase()))];
        const response = await fetch(root + 'cart/update.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({discount:codes.join(',')})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Coupon could not be applied.');
        return refresh();
      });
      const entry = cart.discount_codes?.find(item => item.code.toUpperCase() === code.toUpperCase());
      const applied = [...(cart.cart_level_discount_applications || []),...cart.items.flatMap(item => (item.line_level_discount_allocations || []).map(allocation => allocation.discount_application))].some(item => item?.type === 'discount_code' && item.title.toUpperCase() === code.toUpperCase());
      section.dataset.couponState = clear ? 'removed' : entry?.applicable === false ? 'error' : applied || entry?.applicable === true ? 'applied' : 'pending';
      status.textContent = clear ? section.dataset.couponRemoved : entry?.applicable === false ? message('couponIneligible', 'This coupon is not eligible for your current cart.') : applied || entry?.applicable === true ? code.toUpperCase() + ' ' + message('couponApplied', 'applied. Your cart total has been updated.') : message('couponPending', code.toUpperCase() + ' submitted. Shopify will confirm eligibility and savings at checkout.');
      if (document.querySelector('.cart-page') && (clear || applied || entry?.applicable === true)) window.location.reload();
    } catch (error) {
      section.dataset.couponState = 'error';
      status.textContent = error.message || message('couponError', 'Unable to apply coupon. Please try again.');
    } finally {
      couponBusy = false;
      controls.forEach(button => { button.disabled = false; });
    }
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-coupon-quick],[data-coupon-apply],[data-coupon-clear]');
    if (!button) return;
    event.preventDefault();
    const section = button.closest('[data-cart-coupon]');
    applyCoupon(section,button.dataset.couponQuick || section.querySelector('[data-coupon-input]')?.value || '', button.hasAttribute('data-coupon-clear'));
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Enter' || !event.target.matches('[data-coupon-input]')) return;
    event.preventDefault();
    applyCoupon(event.target.closest('[data-cart-coupon]'),event.target.value);
  });

  let cartInitialized = false;
  const initializeCart = () => {
    if (cartInitialized || !window.PawCart?.refresh) return;
    cartInitialized = true;
    window.PawCart.refresh().catch(()=>{});
  };
  initializeCart();
  if (!cartInitialized) {
    document.addEventListener('DOMContentLoaded', initializeCart, {once:true});
    window.addEventListener('load', initializeCart, {once:true});
  }
})();




